import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

/**
 * Angular keeps a page when only its route params change (order 2415 → 2414), so pages that load once in
 * ngOnInit would show stale data. Routes with `data: { remountOnParamChange: true }` get a fresh page
 * instead; used by Next / previous order (Shift J / K) and next / previous document (J / K).
 */
@Injectable()
export class RemountRouteReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (!super.shouldReuseRoute(future, curr)) return false;
    if (!future.routeConfig?.data?.['remountOnParamChange']) return true;
    const keys = new Set([...Object.keys(future.params), ...Object.keys(curr.params)]);
    return [...keys].every((key) => future.params[key] === curr.params[key]);
  }
}
